

$(function () {
    $('input').iCheck({
        checkboxClass: 'icheckbox_flat-red',
        radioClass: 'iradio_flat-red',
        increaseArea: '20%' // optional
    });
});


addEventListener("DOMContentLoaded", (event) => {
    window.cutFilters()
    window.mobileFiltersPrepare()
});


window.mobileFiltersPrepare = function () {
    var filters = document.querySelectorAll('[data-toggle="dropdown-filters"]')
    filters.forEach(filtersItem => {
        filtersItem.addEventListener("click", (event) => {
            var filterDropdown = document.querySelectorAll(event.target.dataset.target)
            filterDropdown.forEach(dropdownItem => {
                dropdownItem.classList.add("show")

                var closeBtns = dropdownItem.querySelectorAll(".filter-close")

                closeBtns.forEach(btnCloseItem => {
                    btnCloseItem.addEventListener("click", (eventClose) => {
                        dropdownItem.classList.remove("show")
                    })
                })

            })

            

        })
    })    
}


window.cutFilters = function () {
    var filtersBlocks = document.querySelectorAll(".filter-content")

    filtersBlocks.forEach(filterItem => {

        var elements = filterItem.querySelectorAll(".checkbox")

        if (elements.length > 5) {
            prepareFilterBlockItem(filterItem)
        }
    })
}

window.prepareFilterBlockItem = function (filterItem, buttonAdd=null) {
    filterItem.classList.add("filter-content--cut")

    var elements = filterItem.querySelectorAll(".checkbox")

    var counter = 0

    elements.forEach(checkboeItem => {
        counter++
        if (counter > 5) {
            checkboeItem.classList.add("hidden")
        }
    })

    if (buttonAdd) { buttonAdd.remove() }

    var button = document.createElement("button")
    button.classList.add("btn", "btn-link", "filter-content__btn-more", "load-filters-btn")
    button.innerHTML = "Раскрыть список"
    button.addEventListener("click", (event) => {
        var contentFilterElement = event.target.parentElement.querySelector(".filter-content")
        expandFilterBlockItem(contentFilterElement, button)
    })
    
    filterItem.parentElement.append(button)
}

window.expandFilterBlockItem = function (contentFilterElement, button) {
    contentFilterElement.classList.remove("filter-content--cut")
    button.remove()

    var elements = contentFilterElement.querySelectorAll(".checkbox")
    elements.forEach(checkboeItem => {
        checkboeItem.classList.remove("hidden")
    })

    var buttonAdd = document.createElement("button")
    buttonAdd.classList.add("btn", "btn-link", "filter-content__btn-more", "load-filters-btn")
    buttonAdd.innerHTML = "Свернуть список"

    buttonAdd.addEventListener("click", (event) => {
        var filterItem = event.target.parentElement.querySelector(".filter-content")
        prepareFilterBlockItem(filterItem, buttonAdd)
    })

    contentFilterElement.parentElement.append(buttonAdd)
}
